var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{ref:"list",attrs:{"tableCheckbox":false,"info":_vm.info,"search-time":false,"tableTitle":_vm.tableTitle,"searchBtn":false,"searchUrl":_vm.url,"form":_vm.form,"back":_vm.back,"refresh":false,"InfoHref":_vm.InfoHref}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }